import type { FormEachNode } from '../../../types/layout';

export function createEmptyEachItem(node: FormEachNode): Record<string, unknown> | string {
  if (node.primitiveItem) {
    return '';
  }

  const emptyItem: Record<string, unknown> = {};
  for (const f of node.itemFields) {
    emptyItem[f.name] = null;
  }
  return emptyItem;
}
